import axios from '.'
import _ from 'lodash'
import queryString from 'query-string'

export default {
  getAllPerformers,
  getAllOnlinePerformers
}

async function getAllPerformers(payload = {}) {
  let url = '/users/performers'
  if (!_.isEmpty(payload)) {
    url += `?${queryString.stringify(payload)}`
  }
  const response = await axios.get(url)
  return response.data
}

async function getAllOnlinePerformers(payload = {}) {
  let url = '/users/get-all-online-performers'
  if (!_.isEmpty(payload)) {
    url += `?${queryString.stringify(payload)}`
  }
  const response = await axios.get(url)
  return response.data
}
